<template>
  <svg class="svg-title">
    <defs>
      <linearGradient id="svg-text" gradientUnits="userSpaceOnUse" x1="0" y1="10" x2="0" y2="50">
        <stop offset="0" style="stop-color:#FFFFFF" />
        <stop offset="0.3" style="stop-color:#FFFFFF" />
        <stop offset="1" style="stop-color:#FFFFFF" />
      </linearGradient>
    </defs>
    <text text-anchor="middle" class="gradient-text" :x="x" :y="y">{{ text }}</text>
  </svg>
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    text: {
      type: String,
      default: ''
    },
    x: {
      type: String,
      default: '50%'
    },
    y: {
      type: String,
      default: '66%'
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.svg-title {
  width: 100%;
  height: 40px;

  .gradient-text {
    fill: url(#svg-text);
    font-size: 16px;
  }
}
</style>
